import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router';

export default class CityList extends Component {
  static propTypes = {
    cities: PropTypes.arrayOf(
      PropTypes.shape({
        active: PropTypes.bool,
        label: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired
      })
    ).isRequired,
    onlyActive: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      length: props.cities.length
    };
  }

  componentWillReceiveProps(nextProps) {
    const length = nextProps.cities.length;
    if (this.state.length !== length) {
      this.setState({ length: nextProps.cities.length });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.onlyActive !== nextProps.onlyActive) {
      return true;
    }
    return this.state.length !== nextState.length;
  }

  render() {
    const props = this.props;

    const cities = props.onlyActive
      ? props.cities.filter(city => city.active)
      : [].concat(props.cities);
    const length = cities.length;

    const numberOfLists = 4;
    const perList = Math.ceil(length / numberOfLists);

    const lists = [];
    for (let i = numberOfLists; i > 0; i--) {
      lists.push(cities.splice(0, perList));
    }

    return (
      <Row className="city-list">
        {lists.map((list, idx) => (
          <Col key={idx} sm={3} xs={6}>
            {list.map((city, idx) => (
              <Link key={idx} to={`/${city.slug}`}>
                {city.label}
              </Link>
            ))}
          </Col>
        ))}
      </Row>
    );
  }
}
